export default { CARD: 'card', BOX: 'box' };
